import './index.scss';
const dsList = [
    [12],
    [6, 6],
    [4, 4, 4],
    [3, 3, 3, 3],
    [2, 2, 2, 2, 2, 2],
    [3, 9],
    [9, 3],
    [3, 6, 3],
    [4, 8],
    [8, 4],
];
export function makeColumnDom(config) {
    const { value, onClick } = config || {};
    return dsList.map((item) => {
        const tempValue = item.length > 1 ? item.join(':') : `${item[0]}`;
        const active = tempValue === value;
        return (<div onClick={() => {
                onClick?.(tempValue);
            }} className={`cn-layout-setter-item-block ${active ? 'active' : ''}`}>
        {tempValue === '6' ? (<>
            <div style={{ flex: 1 }} className="cn-layout-setter-item-block-child"/>
            <div style={{ flex: 1, opacity: 0 }} className="cn-layout-setter-item-block-child"/>
          </>) : (item.map((item2) => {
                return <div style={{ flex: item2 }} className="cn-layout-setter-item-block-child"/>;
            }))}
      </div>);
    });
}
